export default "__VITE_ASSET__ce8a0e99__"